<template>
  <div class="div-container">
    <validation-observer ref="refFormObserver">
      <b-form>
        <b-row>
          <b-col cols="6">
            <!-- email -->
            <validation-provider
              #default="validationContext"
              :name="$t('users.email')"
              :rules="itemData.email && itemData.email.includes('@') && !itemData.email.match(/^[^@]*@\d+$/) ? 'email' : ''"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('users.email')"
                label-for="email"
              >
                <b-form-input
                  id="email"
                  v-model="itemData.email"
                  :state="getValidationState(validationContext)"
                  trim
                  autocomplete="off"
                  :disabled="!isAdd"
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <!-- username -->
            <validation-provider
              #default="validationContext"
              :name="$t('users.username')"
              rules="required"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('users.username')"
                label-for="username"
              >
                <b-form-input
                  id="username"
                  v-model="itemData.username"
                  :state="getValidationState(validationContext)"
                  trim
                  autocomplete="off"
                  :disabled="!isAdd"
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6">
            <!-- Name -->
            <validation-provider
              #default="validationContext"
              name="name"
              rules="required"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('users.name')"
                label-for="name"
              >
                <b-form-input
                  id="name"
                  v-model="itemData.name"
                  :state="getValidationState(validationContext)"
                  trim
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <!-- last_name -->
            <validation-provider
              #default="validationContext"
              :name="$t('users.last_name')"
              rules="required"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('users.last_name')"
                label-for="last_name"
              >
                <b-form-input
                  id="last_name"
                  v-model="itemData.last_name"
                  :state="getValidationState(validationContext)"
                  trim
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6">
            <!-- Number Fields -->
            <b-row>
              <b-col cols="5" style="padding-right: 0">
                <!-- country -->
                <validation-provider
                  #default="validationContext"
                  :name="$t('country.telephone_code')"
                  rules="required"
                >
                  <b-form-group
                    class="text-capitalize"
                    :label="$t('country.telephone_code')"
                    label-for="id_country"
                    :state="getValidationState(validationContext)"
                  >
                    <v-select
                      v-model="itemData.id_country"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="countryOptions"
                      :clearable="false"
                      :reduce="(val) => val.value"
                      input-id="id_country"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider></b-col
              >
              <b-col cols="7" style="padding-left: 0">
                <!-- phone_number -->
                <validation-provider
                  #default="validationContext"
                  :name="$t('users.phone_number')"
                  rules="numeric|min:10"
                >
                  <b-form-group
                    class="text-capitalize input-width"
                    :label="$t('users.phone_number')"
                    label-for="phone_number"
                  >
                    <b-form-input
                      id="phone_number"
                      v-model="itemData.phone_number"
                      :state="getValidationState(validationContext)"
                      trim
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider></b-col
              >
            </b-row>
          </b-col>

          <b-col cols="6">
            <!-- plate_number -->
            <validation-provider
              #default="validationContext"
              :name="$t('users.plate_number')"
              rules=""
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('users.plate_number')"
                label-for="plate_number"
              >
                <b-form-input
                  id="plate_number"
                  v-model="itemData.plate_number"
                  :state="getValidationState(validationContext)"
                  trim
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <!-- allowed_tabs -->
            <validation-provider
              #default="validationContext"
              :name="$t('users.allowed_tabs')"
              rules="numeric|min_value:1"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('users.allowed_tabs')"
                label-for="allowed_tabs"
              >
                <b-form-input
                  id="allowed_tabs"
                  v-model="itemData.allowed_tabs"
                  :state="getValidationState(validationContext)"
                  type="number"
                  min="1"
                  :placeholder="DEFAULT_ALLOWED_TABS"
                  trim
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row v-show="false">
          <b-col cols="6">
            <!-- allowed_units_live_video_flows -->
            <validation-provider
              #default="validationContext"
              :name="$t('users.allowed_units_live_video_flows')"
              rules="required"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('users.allowed_units_live_video_flows')"
                label-for="allowed_units_live_video_flows"
              >
                <b-form-input
                  id="allowed_units_live_video_flows"
                  v-model="itemData.allowed_units_live_video_flows"
                  :state="getValidationState(validationContext)"
                  trim
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6">
            <!-- vpn_access -->
            <validation-provider name="vpn_access" rules="required">
              <b-form-checkbox
                id="vpn_access"
                v-model="itemData.vpn_access"
                name="vpn_access"
                value="1"
                unchecked-value="0"
                class="my-1 text-capitalize"
                switch
              >
                {{ $t("users.vpn_access") }}
              </b-form-checkbox>
            </validation-provider>

            <!-- video wall-->
            <validation-provider name="video_wall" rules="required">
              <b-form-checkbox
                id="video_wall"
                v-model="itemData.video_wall"
                name="video_wall"
                value="1"
                unchecked-value="0"
                class="my-1 text-capitalize"
                switch
              >
                video wall
              </b-form-checkbox>
            </validation-provider>

            <!-- chat -->
          <validation-provider name="enabled_chat" rules="required">
            <b-form-checkbox
              id="enabled_chat"
              v-model="itemData.enabled_chat"
              name="enabled_chat"
              value="1"
              unchecked-value="0"
              class="my-1 text-capitalize"
              switch
            >
              chat
            </b-form-checkbox>
          </validation-provider>

          <validation-provider name="enabled_helpdesk" rules="required">
            <b-form-checkbox
              id="enabled_helpdesk"
              v-model="itemData.enabled_helpdesk"
              name="enabled_helpdesk"
              value="1"
              unchecked-value="0"
              class="my-1 text-capitalize"
              switch
            >
              Helpdesk
            </b-form-checkbox>
          </validation-provider>

            <!-- active -->
            <validation-provider
              name="active"
              rules="required">
              <b-form-checkbox
                id="active"
                v-model="itemData.active"
                name="active"
                value="1"
                unchecked-value="0"
                class="my-1 text-capitalize"
                :disabled="isAdd || (!isAdd && !itemData.verify_email)"
                switch
              >
                {{ $t("users.active") }}
              </b-form-checkbox>
            </validation-provider>
          </b-col>

          <b-col cols="6" v-if="$can('update_history_time', 'Alarm')">
            <!-- alarm history -->
            <b-form-group
              class="text-capitalize"
              :label="$t('users.alarms_history')"
              v-slot="{ ariaDescribedby }"
            >
              <b-form-radio
                v-model="selected"
                :aria-describedby="ariaDescribedby"
                name="some-radios"
                value="hours"
                class="my-1 text-capitalize"
                @input="changeFilter"
              >
                {{ $t("users.alarm_history_per_hours") }}
              </b-form-radio>
              <b-form-input
                id="alarm_history_per_hours"
                v-model="itemData.alarm_history_per_hours"
                trim
                v-show="selected == 'hours'"
                type="number"
              />

              <b-form-radio
                v-model="selected"
                :aria-describedby="ariaDescribedby"
                name="some-radios"
                value="days"
                class="my-1 text-capitalize"
                @input="changeFilter"
              >
                {{ $t("users.alarm_history_per_days") }}
              </b-form-radio>
              <b-form-input
                id="alarm_history_per_days"
                v-model="itemData.alarm_history_per_days"
                trim
                v-show="selected == 'days'"
                type="number"
              />

              <b-form-radio
                v-model="selected"
                :aria-describedby="ariaDescribedby"
                name="some-radios"
                value="records"
                class="my-1 text-capitalize"
                @input="changeFilter"
              >
                {{ $t("users.alarm_history_by_records") }}
              </b-form-radio>
              <b-form-input
                id="alarm_history_by_records"
                v-model="itemData.alarm_history_by_records"
                trim
                v-show="selected == 'records'"
                type="number"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <!-- facility app -->
            <validation-provider
              #default="validationContext"
              :name="$tc('unit.title', 1)"
            >
              <b-form-checkbox
                v-model="facilityApp"
                name="facilityApp"
                value="1"
                unchecked-value="0"
                class="my-1 text-capitalize"
                switch
              >
                {{ $tc('unit.title_app') }}
                <feather-icon
                  icon="InfoIcon"
                  size="20"
                  class="ml-25 text-muted"
                  v-b-tooltip.hover
                  :title="$tc('unit.description_app')"
                />
              </b-form-checkbox>

              <b-form-group
                data-cy="facility"
                class="text-capitalize"
                :label="$tc('unit.title', 1)"
                label-for="id_unit"
                :state="getValidationState(validationContext)"
                v-if="facilityApp == 1"
              >
                <select-paginate-unit
                  :id_unit.sync="itemData.id_unit"
                  input-id="id_unit"
                  :ids_tenant="itemData.tenant"
                  :disabled="!itemData.tenant || itemData.tenant.length === 0"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <span v-if="userGroup" class="groupName" @click="$can('update', 'Group') ? openGroup(itemData.groups[0].id) : null">
              {{ $t("users.belogs_user") + itemData.groups[0].name }}
            </span>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import {
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BFormCheckbox,
  BFormRadio,
} from "bootstrap-vue";
import { ref, watch, onMounted } from "@vue/composition-api";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import formValidation from "@core/comp-functions/forms/form-validation";
import vSelect from "vue-select";
import { required, alphaNum, email, positive, required_if, length } from '@validations';
import SelectPaginateUnit from "@/views/components/SelectPaginateUnit.vue";

const DEFAULT_ALLOWED_TABS = "5";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    BFormCheckbox,
    BFormRadio,
    SelectPaginateUnit,
  },
  props: {
    propItemData: {
      type: Object,
      required: false,
    },
    countryOptions: {
      type: Array,
      required: true,
    },
    isAdd: {
      type: Boolean,
      required: true,
    },
    userGroup: Boolean,
  },
  data() {
    return {
      required,
      alphaNum,
      email,
      positive,
      required_if,
    };
  },

  setup(props, { emit }) {
    const isUpdatingFromProps = ref(false);
    const selected = ref("hours");
    const facilityApp = ref(0);
    const { refFormObserver, getValidationState } = formValidation();
    const itemData = ref(JSON.parse(JSON.stringify(props.propItemData)));

    // Watch for changes in id_unit to update facilityApp
    watch(() => itemData.value.id_unit, (newValue) => {
      if (newValue) {
        facilityApp.value = 1;
      }
    }, { immediate: true });

    const changeFilter = () => {
      itemData.value.alarm_history_per_hours = 0;
      itemData.value.alarm_history_per_days = 0;
      itemData.value.alarm_history_by_records = 0;
    };

    onMounted(() => {
      if (props.isAdd) {
        setTimeout(() => {
          props.countryOptions.forEach(element => {
          if (element.label == "usa (+1)")
              itemData.value.id_country = element.value
          })
        }, 300)
        itemData.value.active = 0;
        emit("update:itemData", { ['active']: 0 });
      }
    })

    const validateStep = () => {
      return refFormObserver.value.validate();
    };

    const setupWatcher = (itemData, key) => {
      watch(
        () => itemData.value[key],
        (newValue, oldValue) => {
          if (newValue !== oldValue) {
            emit("update:itemData", { [key]: newValue });
          }
        }
      );
    };

    const openGroup = (groupId) => {
        const groupUrl = `${window.location.origin}/#/group?groupId=${groupId}`;
        window.open(groupUrl);
    }

    watch(
      () => props.propItemData,
      (newValue) => {
        itemData.value = { ...newValue };
      },
      { deep: true }
    );

    setupWatcher(itemData, "email");
    setupWatcher(itemData, "username");
    setupWatcher(itemData, "name");
    setupWatcher(itemData, "last_name");
    setupWatcher(itemData, "id_country");
    setupWatcher(itemData, "phone_number");
    setupWatcher(itemData, "plate_number");
    setupWatcher(itemData, "allowed_tabs");
    setupWatcher(itemData, "allowed_units_live_video_flows");
    setupWatcher(itemData, "alarm_history_per_hours");
    setupWatcher(itemData, "alarm_history_per_days");
    setupWatcher(itemData, "alarm_history_by_records");
    setupWatcher(itemData, "vpn_access");
    setupWatcher(itemData, "active");
    setupWatcher(itemData, "video_wall");
    setupWatcher(itemData, "enabled_chat");
    setupWatcher(itemData, "enabled_helpdesk");
    setupWatcher(itemData, "id_unit");
    return {
      itemData,
      changeFilter,
      refFormObserver,
      getValidationState,
      selected,
      validateStep,
      isUpdatingFromProps,
      openGroup,
      facilityApp,
      DEFAULT_ALLOWED_TABS,
    };
  },
};
</script>

<style scoped>

.input-width {
  width: 80%; /* 80% father container */
  margin: 0 auto; /* Center in the father */
  display: block; /* block to marginauto */
}
.groupName{
  font-size: 1.3rem;
  cursor: pointer;
}
</style>
